import { render, staticRenderFns } from "./typesRoomPage.vue?vue&type=template&id=aafae020&scoped=true&"
import script from "./typesRoomPage.vue?vue&type=script&lang=js&"
export * from "./typesRoomPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafae020",
  null
  
)

export default component.exports